import * as yup from 'yup';
import { PartnerSchema } from '../partners/partners.schema';

export const PartnerFarmLinkSchema = yup.object({
  id: yup.number().defined(),
  raptor_farm_id: yup.number().defined(),
  partner_farm_key: yup.string().defined(),
  status: yup.number().defined(),
  creator_id: yup.number().nullable(),
  updator_id: yup.number().nullable(),
  created_at: yup.string().nullable(),
  updated_at: yup.string().nullable(),
  partner: PartnerSchema.defined(),
});
export type PartnerFarmLink = yup.InferType<typeof PartnerFarmLinkSchema>;

export const PartnerFarmLinksResponseSchema = yup
  .array()
  .of(PartnerFarmLinkSchema.defined())
  .defined();
export type PartnerFarmLinksResponse = yup.InferType<
  typeof PartnerFarmLinksResponseSchema
>;

export const PartnerFarmResponseSchema = yup.object({
  id: yup.number().defined(),
  partner_id: yup.number().defined(),
  raptor_farm_id: yup.number().defined(),
  partner_farm_key: yup.string().defined(),
  status: yup.number().defined(),
  creator_id: yup.number().nullable(),
  updator_id: yup.number().nullable(),
  created_at: yup.string().nullable(),
  updated_at: yup.string().nullable(),
});
export type PartnerFarmResponse = yup.InferType<
  typeof PartnerFarmResponseSchema
>;

export const PARTNER_FARM_STATUS_ACTIVE = 0;
export const PARTNER_FARM_STATUS_INACTIVE = 99;

export interface AddPartnerFarmRequest {
  partner_farm_key: string;
}

export interface UpdatePartnerFarmKeyRequest {
  partner_farm_key: string;
}

export interface UpdatePartnerFarmStatusRequest {
  partner_farm_key: string;
  status:
    | typeof PARTNER_FARM_STATUS_ACTIVE
    | typeof PARTNER_FARM_STATUS_INACTIVE;
}
